import React, { useState, useEffect } from "react"
import { mq } from "src/styles"

export function useWindowWidth() {
  const [width, setWidth] = useState(
    typeof window !== "undefined" ? window.innerWidth : 0
  )

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth)
    window.addEventListener("resize", handleResize)
    return () => window.removeEventListener("resize", handleResize)
  }, [])

  return width
}

const widthToRenderer = (
  winWidth,
  small,
  medium,
  large,
  larger,
  extraLarge,
  custom
) => {
  if (custom?.breakpoint && winWidth >= custom?.breakpoint) {
    // For custom breakpoint if necessary
    return custom.content
  } else if (winWidth >= mq.extraLargeBreakpoint) {
    return extraLarge || larger || large || medium || small
  } else if (winWidth >= mq.largerBreakpoint) {
    return larger || large || medium || small
  } else if (winWidth >= mq.largeBreakpoint) {
    return large || medium || small
  } else if (winWidth >= mq.mediumBreakpoint) {
    return medium || small
  } else if (winWidth < mq.mediumBreakpoint) {
    return small
  }
}

export default function ResponsiveComponent({
  small,
  medium,
  large,
  larger,
  extraLarge,
  custom,
}) {
  const winWidth = useWindowWidth()

  return (
    <>
      {widthToRenderer(
        winWidth,
        small,
        medium,
        large,
        larger,
        extraLarge,
        custom
      )}
    </>
  )
}
